import { useLocation } from 'react-router-dom'
import {
  ROUTE_HOME,
  ROUTE_TRANSACTIONS_ALL_TRANSACTIONS,
  ROUTE_TRANSACTIONS_STATEMENTS,
} from '@/routes/paths'
import { StaticAnnouncement } from '@/components/static-announcement'
import { Icons } from '@/theme/Images'

const isDiscontinuedBannerEnabled = () => import.meta.env.VITE_ENABLE_DISCONTINUED_BANNER === 'true'

function getBannerClass(pathname) {
  const base = 'bg-bgGray md:mx-[10%] my-6 md:mt-[2%]'
  return [ROUTE_HOME, ROUTE_TRANSACTIONS_ALL_TRANSACTIONS, ROUTE_TRANSACTIONS_STATEMENTS].includes(pathname)
    ? `${base} md:m-0 mx-0`
    : `${base} md:m-0 mx-6`
}

const BANNER_TEXT = (
  <>
    <span className="font-semibold">NOTICE: </span>
    The Fasten Rewards Card program is being discontinued. Beginning March 6, 2026, accounts are being transitioned
    through a phased closure process. Refer to the email notice sent to you for important dates and instructions.
  </>
)

const FastenDiscontinuedBanner = () => {
  const { pathname } = useLocation()
  const pathSegment = pathname?.split('/').at(-1) ?? ''
  const bannerClass = getBannerClass(pathSegment)

  if (!isDiscontinuedBannerEnabled()) {
    return null
  }

  return (
    <div className={bannerClass}>
      <div className="flex flex-col md:gap-8 gap-5">
        <StaticAnnouncement
          noShadow
          startIcon={Icons.grayNotificationIcon}
          text={BANNER_TEXT}
        />
      </div>
    </div>
  )
}

export default FastenDiscontinuedBanner
